// jquery does not currently support es6 way of importing so we need to do it old school
var $ = require('jquery');

export class MaterialBank {
  private searchEnabled: boolean = false;
  private $el;
  private block: string = 'material-bank';
  private jsBlock: string = 'js-material-bank';
  private $items;
  private $search;

  constructor(materialBankElement) {
    this.$el = $(materialBankElement);
    this.$items = this.$el.find('.' + this.jsBlock + '__item');
    this.$search = this.$el.find('.' + this.jsBlock + '__search');
  }

  activateSearch() {
    const self = this;

    this.$search.on('keyup', function () {
      const searchReg = new RegExp(self.$search.val().toUpperCase());
      self.$items.each(function () {
        const $this = $(this);
        const title = $this.find('.' + self.jsBlock + '__item-title').text().toUpperCase();
        const description = $this.find('.' + self.block + '__item-description').text().toUpperCase();
        const product = $this.data('product').toUpperCase();

        const show = searchReg.test(title) || searchReg.test(description) || searchReg.test(product);
        $this.toggle( show );

      });
    });
  }

  init() {
    if (!this.$el.length) {
      return;
    }

    if (this.$search.length) {
      this.activateSearch();
    }
  }
}
